// extracted by css-extract-rspack-plugin
export default {"heroImageWrapper":"FlexSuiteHero-module__heroImageWrapper__J69XL","heroBg":"FlexSuiteHero-module__heroBg__CHG0A"};